import React from "react";
import Footer from "../Fotter";

function DisclaimerPolicy() {
  return (
    <div>
      <div className=" mx-auto px-4 py-6">
        <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">
          Disclaimer Policy
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          The information contained in this website is for general information
          purposes only. The information is provided by bharatCod and while we
          endeavor to keep the information up to date and correct, we make no
          representations or warranties of any kind, express or implied, about
          the completeness, accuracy, reliability, suitability or availability
          with respect to the website or the information, products, services, or
          related graphics contained on the website for any purpose. Any
          reliance you place on such information is therefore strictly at your
          own risk.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          In no event will we be liable for any loss or damage including without
          limitation, indirect or consequential loss or damage, or any loss or
          damage whatsoever arising from loss of data or profits arise out of,
          or in connection with, the use of this website.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          Through this website you are able to link to other websites which are
          not under the control of bharatCod. We have no control over the
          nature, content and availability of those sites. The inclusion of any
          links does not necessarily imply a recommendation or endorse the views
          expressed within them.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          Every effort is made to keep the website up and running smoothly.
          However, bharatCod takes no responsibility for, and will not be liable
          for, the website being temporarily unavailable due to technical issues
          beyond our control.
        </p>

        <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p>
            <strong>Address:</strong> 403, Shagun Tower, Above Apna Sweets,
            Scheme Number 54,P.u.4,AB Rd,vijay Nagar,Indore,Madhy Pradesh 452010
            Pradesh
          </p>
          <p>
            <strong>Phone:</strong> (+91) 9399456176
          </p>
          <p>
            <strong>E-mail:</strong> info@bharatCod.com
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="http://www.bharatCod.com"
              className="text-blue-500 underline"
            >
              www.bharatCod.com
            </a>
          </p>
          <div className="mb-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default DisclaimerPolicy;
